var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "gems-panel"
  }, [_c('div', {
    staticClass: "gems-top"
  }, [_c('div', {
    staticClass: "gems-balance"
  }, [_c('img', {
    staticClass: "gems-art",
    attrs: {
      "src": "/assets/gifting/gems-illustration.svg",
      "alt": "Wallet"
    }
  }), _c('span', {
    staticClass: "gems-balance-label"
  }, [_vm._v("Wallet Balance")]), _c('strong', {
    staticClass: "gems-balance-value"
  }, [_c('span', {
    staticClass: "gems-currency"
  }, [_vm._v("Ð")]), _vm._v(_vm._s(_vm.balanceLoaded ? _vm.formatAmount(_vm.balance) : "—") + " ")]), _vm._m(0)]), _c('div', {
    staticClass: "gems-convert"
  }, [_c('h3', [_vm._v("Convert to Gems")]), _c('div', {
    staticClass: "convert-rows"
  }, [_c('div', {
    staticClass: "convert-row"
  }, [_c('img', {
    attrs: {
      "src": "/assets/gifting/symbol-gem.svg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "convert-field"
  }, [_c('label', {
    attrs: {
      "for": "convert-gems"
    }
  }, [_vm._v("Receive")]), _c('input', {
    attrs: {
      "id": "convert-gems",
      "type": "text",
      "inputmode": "numeric",
      "placeholder": "0",
      "disabled": !_vm.balanceLoaded || !_vm.gemsPerAed
    },
    domProps: {
      "value": _vm.gemsInput
    },
    on: {
      "input": _vm.onGemsInput
    }
  })]), _c('span', {
    staticClass: "convert-unit"
  }, [_vm._v("GEM")])]), _vm._m(1), _c('div', {
    staticClass: "convert-row"
  }, [_c('img', {
    attrs: {
      "src": "/assets/gifting/symbol-aed.svg",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "convert-field"
  }, [_c('label', {
    attrs: {
      "for": "convert-amount"
    }
  }, [_vm._v("Convert")]), _c('input', {
    attrs: {
      "id": "convert-amount",
      "type": "text",
      "placeholder": "0",
      "readonly": "",
      "tabindex": "-1"
    },
    domProps: {
      "value": _vm.aedDisplay
    }
  })]), _c('span', {
    staticClass: "convert-unit"
  }, [_vm._v("AED")])])]), _c('div', {
    staticClass: "convert-pills"
  }, [_vm._m(2), _c('span', {
    staticClass: "convert-pill"
  }, [_c('img', {
    attrs: {
      "src": "/assets/gifting/gem-mini.svg",
      "alt": ""
    }
  }), _vm._v(" 1 AED = " + _vm._s(_vm.rateLabel) + " GEM ")])]), _vm.error ? _c('p', {
    staticClass: "convert-error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _c('b-button', {
    staticClass: "convert-cta",
    attrs: {
      "type": "button",
      "disabled": !_vm.canConvert || _vm.converting
    },
    on: {
      "click": _vm.convert
    }
  }, [_vm._v(" " + _vm._s(_vm.converting ? "Converting…" : "Convert") + " ")])], 1)]), _c('div', {
    staticClass: "gems-txns"
  }, [_vm._m(3), _c('div', {
    staticClass: "gems-table-scroll"
  }, [_c('table', {
    staticClass: "gems-table"
  }, [_vm._m(4), _c('tbody', [_vm._l(_vm.transactions, function (txn) {
    return _c('tr', {
      key: txn.id
    }, [_c('td', [_vm._v(_vm._s(txn.details))]), _c('td', {
      staticClass: "txn-date"
    }, [_vm._v(_vm._s(_vm.formatDate(txn.at)))]), _c('td', {
      staticClass: "txn-gems"
    }, [_vm._v(" " + _vm._s(txn.gems ? ("+" + (txn.gems) + " Gems") : "—") + " ")]), _c('td', {
      staticClass: "txn-amount"
    }, [_vm._v("AED " + _vm._s(_vm.formatAmount(txn.amount)))]), _c('td', {
      staticClass: "txn-status"
    }, [_vm._v(_vm._s(txn.status))])]);
  }), !_vm.transactions.length && !_vm.transactionsFailed ? _c('tr', [_c('td', {
    staticClass: "txn-empty",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v(" Your wallet activity will appear here. ")])]) : _vm._e()], 2)])]), _vm.hasMoreTransactions ? _c('div', {
    staticClass: "gems-load-more"
  }, [_c('b-button', {
    staticClass: "btn-load-more",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingMore
    },
    on: {
      "click": _vm.loadMore
    }
  }, [_vm._v(" " + _vm._s(_vm.loadingMore ? "Loading…" : "Load more") + " ")])], 1) : _vm._e()])]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "gems-hint"
  }, [_c('span', {
    staticClass: "gems-hint-icon"
  }, [_vm._v("i")]), _c('span', [_vm._v(" Use your balance to convert for gems or to withdraw balance use "), _c('a', {
    attrs: {
      "href": "https://mywhoosh.com/getting-started-mywhoosh-cycling-app/",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_vm._v("Link App")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "convert-swap"
  }, [_c('img', {
    attrs: {
      "src": "/assets/gifting/swap-circle.svg",
      "alt": ""
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "convert-pill"
  }, [_c('img', {
    attrs: {
      "src": "/assets/gifting/icon-zero-fee.svg",
      "alt": ""
    }
  }), _vm._v(" Zero Fee ")]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "gems-txns-head"
  }, [_c('h3', [_vm._v("Recent Transactions")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Details")]), _c('th', [_vm._v("Date & Time")]), _c('th', [_vm._v("Gems")]), _c('th', [_vm._v("Amount (AED)")]), _c('th', [_vm._v("Status")])])]);
}]

export { render, staticRenderFns }